import React from 'react';
import ProtectedAdminPanel from '../components/admin/ProtectedAdminPanel';


const AdminPage = () => {
  // Renderizza direttamente ProtectedAdminPanel senza avvolgerlo in MainLayout
  return <ProtectedAdminPanel />;
};

export default AdminPage;